import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generatePositionTableRow } from '../CallsheetUtils';
import i18n from '../../../i18n';
import styles from '../../../assets/stylesheets/CallsheetInlineStyles';
import { employeePositions } from '../../../constants/employeePositions';

class PlanningSheet extends Component {
  render() {
    const { info, name, renderForEmail } = this.props;
    return (
      <table
        border="1"
        style={renderForEmail ? styles.tableEmailWidth : styles.tableFullWidth}
      >
        <thead>
          <tr>
            <th style={styles.locationHeader} colSpan="4">
              <h4>{name}</h4>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th colSpan="2">{i18n.t('setting:callTime')}</th>
            <th colSpan="2">{i18n.t('setting:wrapTime')}</th>
          </tr>
          <tr>
            <td colSpan="2" style={styles.timeCell}>
              {info.callTime}
            </td>
            <td colSpan="2" style={styles.timeCell}>
              {info.wrapTime}
            </td>
          </tr>
          {generatePositionTableRow('assistantProducer', info.positions[employeePositions.ASSISTANT_PRODUCER])}
          {generatePositionTableRow(
            'menswearAssociateProducer',
            info.positions[employeePositions.MENSWEAR_ASSOCIATE_PRODUCER]
          )}
          {generatePositionTableRow(
            'womenswearAssociateProducer',
            info.positions[employeePositions.WOMENSWEAR_ASSOCIATE_PRODUCER]
          )}
          {generatePositionTableRow(
            'accessoriesAssociateProducer',
            info.positions[employeePositions.ACC_ASSOCIATE_PRODUCER]
          )}
          {generatePositionTableRow('retouchProducer', info.positions[employeePositions.RETOUCH_PRODUCER])}
          {generatePositionTableRow(
            'contentAndLocalizationAssociateProducer',
            info.positions[employeePositions.CONTENT_AND_LOCALIZATION_ASSOCIATE_PRODUCER]
          )}
        </tbody>
      </table>
    );
  }
}

PlanningSheet.propTypes = {
  name: PropTypes.string.isRequired,
  info: PropTypes.shape({
    callTime: PropTypes.string.isRequired,
    wrapTime: PropTypes.string.isRequired,
    positions: PropTypes.objectOf(
      PropTypes.shape({
        employees: PropTypes.arrayOf(
          PropTypes.shape({ email: PropTypes.string, name: PropTypes.string })
        )
      })
    )
  }).isRequired,
  renderForEmail: PropTypes.bool.isRequired
};

export default PlanningSheet;
